import React from "react";
import { CircularProgress, Box } from "@mui/material";

function SpinnerMain() {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <CircularProgress size={60} thickness={3} sx={{ color: "var(--secondary-color)" }} />
        </Box>
    );
};

export default SpinnerMain;
